import { render, staticRenderFns } from "./importGoods.vue?vue&type=template&id=15cbf1ae&scoped=true"
import script from "./importGoods.vue?vue&type=script&lang=js"
export * from "./importGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cbf1ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15cbf1ae')) {
      api.createRecord('15cbf1ae', component.options)
    } else {
      api.reload('15cbf1ae', component.options)
    }
    module.hot.accept("./importGoods.vue?vue&type=template&id=15cbf1ae&scoped=true", function () {
      api.rerender('15cbf1ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/broadcast/room/importGoods.vue"
export default component.exports